import pluralize from 'pluralize';

import { CarrierLogoStack } from '@/components/modules/carrier/logo-stack';
import { CarrierNameList } from '@/components/modules/carrier/name-list';
import { Text } from '@/components/text';
import { SegmentModeType } from '@/types/api-types';
import { tv } from '@/utils/styles';

export interface CarrierListProps {
  carrierIds: string[];
  mode: SegmentModeType;
  limit?: number;
  isLocked?: boolean;
  customLabel?: string;
}

const CarrierLogoStackNames = ({ carrierIds, mode, limit = 5, isLocked = false, customLabel }: CarrierListProps) => {
  const carrierCount = carrierIds.length;

  const { subtext } = styles();

  if (isLocked) {
    return (
      <>
        <Text className="m-0 text-baseSm text-text-primary">
          {carrierCount} {pluralize('carriers', carrierCount)}
        </Text>
        <p className={subtext()}>Sign in for details</p>
      </>
    );
  }

  return (
    <>
      <CarrierLogoStack variant="sm" carrierIds={carrierIds} limit={limit} mode={mode} />
      {customLabel ? <p className={subtext()}>{customLabel}</p> : <CarrierNameList carrierIds={carrierIds} />}
    </>
  );
};

const styles = tv({
  slots: {
    subtext:
      'mb-0 ml-0 mr-0 mt-1 overflow-hidden overflow-ellipsis whitespace-nowrap text-sm italic text-text-secondary',
  },
});

export { CarrierLogoStackNames };
